import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

export const getMetricsApi = ({ taskId, pluginType }) => {
  const url = endpoints.goalTracking.metrics;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      taskId,
      pluginType,
    },
  });
};

export const getMetricNameApi = ({ taskId }) => {
  const url = endpoints.goalTracking.metricName;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      taskId,
    },
  });
};

export const linkMetricApi = ({
  taskId,
  metricId,
  pluginType,
  filters,
  name,
  isCustomQuery,
  query,
  queryType,
  ratioQuery,
}) => {
  const url = endpoints.goalTracking.link;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      taskId,
      metricId,
      pluginType,
      filters,
      name,
      isCustomQuery,
      query,
      queryType,
      ratioQuery,
    },
  });
};

export const unlinkMetricApi = ({ taskId }) => {
  const url = endpoints.goalTracking.unlink;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      taskId,
    },
  });
};

export const getQueryStringApi = ({ metricId, filters }) => {
  const url = endpoints.goalTracking.queryString;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      metricId,
      filters,
    },
  });
};
